<template>
  <div id="app">
  <!--Kode Wrapper Start-->  
  <div class="kode_wrapper">
	
    <!--Header Wrap Start-->
    <app-header></app-header>
    <!--Header Wrap Start-->
    
    <router-view/>    
    
    <app-footer></app-footer>
    

  
        
  </div>
  <!--Kode Wrapper End-->

    

  </div>
</template>

<script>

export default {
}
</script>

<style>


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
 
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
